import { observer } from 'mobx-react';
import React, { forwardRef } from 'react';
import { useStores } from '../../../../hooks';
import { CloseButtonModal } from '../../../CloseButton';

import styles from './styles/base_modal.module.scss';

const CentralDrawModal = observer(
  forwardRef(({ children }, ref) => {
    const { modalStore } = useStores();

    const { close } = modalStore;

    return (
      <div className={styles.central_draw}>
        <div className={styles.central_draw_content} ref={ref}>
          <CloseButtonModal handleClose={close} />
          {children}
        </div>
      </div>
    );
  }),
);

export default CentralDrawModal;
